import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import EditProfileModal from "./modals/EditProfileModal";
import ChangePasswordModal from "./modals/ChangePasswordModal";
import LogoutAllDevicesModal from "./modals/LogoutAllDevicesModal";
import ManageSubscriptions from "../modals/ManageSubscriptions";
import ContactSupport from "../modals/ContactSupport";
import DeactivateAccountModal from "./modals/DeactivateAccountModal";

export default function MyAccount() {
  const { user } = useAuthContext();
  const [appUser, setAppUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showLogoutAllModal, setShowLogoutAllModal] = useState(false);
  const [showManageModal, setShowManageModal] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const appUserResponse = await axios.get(
        `${ApiConnectionString}/api/account`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      setAppUser(appUserResponse.data);
      setFirstName(appUserResponse.data.firstName);
      setLastName(appUserResponse.lastName);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [user]);

if (appUser != null) {
  return (
    <div className="container py-4 bcs-account-page">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <h1 className="mb-2 brand-dark-purple">My account</h1>
          <p className="bcs-subtitle mb-4">
            Manage your Border City Software account and settings.
          </p>

          <div className="card shadow-sm mb-4 bcs-account-card">
            <div className="card-body p-4">
              <h5 className="fw-bold mb-3 brand-dark-purple">Profile</h5>

              <p className="mb-1">
                <strong className="brand-dark-purple">Name:</strong> {firstName}{" "}
                {lastName}
              </p>
              <p className="mb-1">
                <strong className="brand-dark-purple">Email:</strong>{" "}
                {appUser?.email}
              </p>

              <div className="d-flex flex-wrap gap-2 mt-3">
                <button
                  onClick={() => setShowEditProfileModal(true)}
                  className="btn brand-purple-outline"
                >
                  Edit profile
                </button>
              </div>
            </div>
          </div>

          <div className="card shadow-sm mb-4 bcs-account-card">
            <div className="card-body p-4">
              <h5 className="fw-bold mb-3 brand-dark-purple">
                Login &amp; security
              </h5>

              <p className="bcs-subtitle mb-3">
                Manage how you sign in and protect your account.
              </p>

              <div className="d-flex flex-wrap gap-2">
                <button
                  onClick={() => setShowPasswordModal(true)}
                  className="btn brand-purple-outline"
                >
                  Change password
                </button>
                <button
                  onClick={() => setShowLogoutAllModal(true)}
                  className="btn brand-purple-outline"
                >
                  Log out of all devices
                </button>
              </div>
            </div>
          </div>

          <div className="card shadow-sm mb-4 bcs-account-card">
            <div className="card-body p-4">
              <h5 className="fw-bold mb-3 brand-dark-purple">Billing</h5>

              <p className="bcs-subtitle mb-3">
                All payments are handled through Stripe. On the Stripe billing
                portal you can view <strong className="brand-dark-purple">invoices</strong>, update your{" "}
                <strong className="brand-dark-purple">payment details</strong>, and manage your
                <strong className="brand-dark-purple"> subscriptions</strong>.
              </p>

              <button
                onClick={() => setShowManageModal(true)}
                className="btn brand-purple-outline"
              >
                View Stripe billing portal
              </button>
            </div>
          </div>

          <div className="card shadow-sm mb-4 bcs-account-card">
            <div className="card-body p-4">
              <h5 className="fw-bold mb-3 brand-dark-purple">Support</h5>

              <p className="bcs-subtitle mb-3">
                Need help with your websites or your account Send a message and
                I will respond soon.
              </p>

              <button
                onClick={() => setShowSupportModal(true)}
                className="btn brand-purple-inline bcs-primary-btn"
              >
                Contact support
              </button>
            </div>
          </div>

          <div className="card border-danger mb-5 bcs-account-card">
            <div className="card-body p-4">
              <h5 className="fw-bold text-danger mb-3">Deactivate account</h5>

              <p className="bcs-subtitle mb-3">
                Permanently Deactivate your account and all associated websites.
                This cannot be undone.
              </p>

              <button
                onClick={() => setShowDeactivateModal(true)}
                className="btn btn-danger"
              >
                Deactivate my account
              </button>
            </div>
          </div>
        </div>
      </div>

      {showSupportModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered bcs-modal-dialog">
              <ContactSupport onClose={() => setShowSupportModal(false)} />
            </div>
          </div>
          <div className="modal-backdrop fade show bcs-modal-backdrop"></div>
        </>
      )}

      <DeactivateAccountModal
        show={showDeactivateModal}
        onClose={() => setShowDeactivateModal(false)}
        user={user}
      />
      <EditProfileModal
        show={showEditProfileModal}
        onClose={() => setShowEditProfileModal(false)}
        onSave={(data) => {
          setFirstName(data.firstName);
          setLastName(data.lastName);
        }}
        appUser={appUser}
        user={user}
      />
      <ChangePasswordModal
        show={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
        user={user}
      />
      <LogoutAllDevicesModal
        show={showLogoutAllModal}
        onClose={() => setShowLogoutAllModal(false)}
      />

      {showManageModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <ManageSubscriptions
                user={user}
                onClose={() => setShowManageModal(false)}
                onSave={async (e) => {
                  setShowManageModal(false);

                  const response = await axios.get(
                    `${ApiConnectionString}/api/BillingPortal`,
                    {
                      headers: { Authorization: `bearer ${user.token}` },
                    }
                  );

                  window.location.href = response.data;
                }}
              />
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
}
}